"use strict";
/**
 * @module "ethpm/registries/web3"
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3RegistryService = void 0;
const url_1 = require("url");
const t = __importStar(require("io-ts"));
const web3_1 = __importDefault(require("web3"));
const config = __importStar(require("../../config"));
const bn_js_1 = __importDefault(require("bn.js"));
const packages_1 = __importDefault(require("./cursors/packages"));
const releases_1 = __importDefault(require("./cursors/releases"));
const registryManifest = require('./simple/registry.json');
const PAGE_SIZE = 10;
class Web3RegistryService {
    constructor(provider, address) {
        this.web3 = new web3_1.default(provider);
        this.address = address;
        const registryABI = registryManifest.contractTypes.PackageRegistry.abi;
        this.registry = new this.web3.eth.Contract(registryABI, this.address);
    }
    // needs testing
    publish(packageName, version, manifest) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.registry.methods.release(packageName, version, manifest).send({});
        });
    }
    numPackageIds() {
        return __awaiter(this, void 0, void 0, function* () {
            const numPackages = yield this.registry.methods.numPackageIds().call();
            return new bn_js_1.default(numPackages);
        });
    }
    getReleaseData(packageName, version) {
        return __awaiter(this, void 0, void 0, function* () {
            const releaseId = yield this.registry.methods.getReleaseId(packageName, version).call();
            const releaseData = yield this.registry.methods.getReleaseData(releaseId).call();
            const ipfsHash = releaseData[2];
            return ipfsHash;
        });
    }
    packages() {
        return __awaiter(this, void 0, void 0, function* () {
            const numPackages = yield this.numPackageIds();
            const allPackageIds = yield this.getAllPackageIds(numPackages);
            const cursor = new packages_1.default(new bn_js_1.default(PAGE_SIZE), numPackages, this.web3, this.registry, allPackageIds);
            const unsortedPackages = yield Promise.all(Array.from(cursor));
            return unsortedPackages.sort();
        });
    }
    getAllPackageIds(numPackages) {
        return __awaiter(this, void 0, void 0, function* () {
            const pageToIds = {};
            let packageCounter = 0;
            const numPages = numPackages.toNumber() / PAGE_SIZE;
            for (let i = 0; i <= numPages; i++) {
                const slice = yield this.registry.methods.getAllPackageIds(packageCounter, PAGE_SIZE).call();
                pageToIds[i] = slice;
                packageCounter += PAGE_SIZE;
            }
            const formattedPageToIds = Object.keys(pageToIds).reduce((result, key) => {
                result[key] = pageToIds[key].packageIds;
                return result;
            }, {});
            return formattedPageToIds;
        });
    }
    getAllReleaseIds(packageName, numReleases) {
        return __awaiter(this, void 0, void 0, function* () {
            const pageToIds = {};
            let releaseCounter = 0;
            const numPages = numReleases.toNumber() / PAGE_SIZE;
            for (let i = 0; i <= numPages; i++) {
                const slice = yield this.registry.methods.getAllReleaseIds(packageName, releaseCounter, PAGE_SIZE).call({});
                pageToIds[i] = slice;
                releaseCounter += PAGE_SIZE;
            }
            const formattedPageToIds = Object.keys(pageToIds).reduce((result, key) => {
                result[key] = pageToIds[key].releaseIds;
                return result;
            }, {});
            return formattedPageToIds;
        });
    }
    package(packageName) {
        return {
            releases: () => __awaiter(this, void 0, void 0, function* () {
                const count = yield this.registry.methods.numReleaseIds(packageName).call();
                const numReleases = new bn_js_1.default(count);
                try {
                    numReleases.toNumber();
                }
                catch (_) {
                    return {};
                }
                const allReleaseIds = yield this.getAllReleaseIds(packageName, numReleases);
                const cursor = new releases_1.default(new bn_js_1.default(PAGE_SIZE), numReleases, this.web3, this.registry, packageName, allReleaseIds);
                const allReleaseData = yield Promise.all(Array.from(cursor));
                const formattedReleases = allReleaseData.reduce((map, obj) => {
                    map[obj.version] = obj.manifestURI;
                    return map;
                }, {});
                return formattedReleases;
            }),
            release: (version) => __awaiter(this, void 0, void 0, function* () {
                const releaseId = yield this.registry.methods.getReleaseId(packageName, version).call();
                const releaseData = yield this.registry.methods.getReleaseData(releaseId).call();
                if (releaseData.manifestURI === '') {
                    throw new Error('Package: ' + packageName + "@" + version + " not found.");
                }
                else {
                    return new url_1.URL(releaseData[2]);
                }
            }),
        };
    }
}
exports.Web3RegistryService = Web3RegistryService;
class Web3RegistryConnector extends config.Connector {
    constructor() {
        super(...arguments);
        this.optionsType = t.interface({
            provider: t.object,
            registryAddress: t.string,
        });
    }
    init({ provider, registryAddress }) {
        return __awaiter(this, void 0, void 0, function* () {
            const service = new Web3RegistryService(provider, registryAddress);
            return service;
        });
    }
}
exports.default = Web3RegistryConnector;
